import type { TOC } from '@ember/component/template-only';

interface MarketCustomReportingThumbnailSignature {
  Args: {
    imageAlt?: string;
    imageURL?: string;
    isLoading?: boolean;
    subtitle?: string;
    title?: string;
  };
  Blocks: {
    subtitle: [];
    title: [];
  };
  Element: HTMLDivElement;
}

const MarketCustomReportingThumbnail = <template>
  <div
    class="custom-reporting__thumbnail flex flex-col
      {{if @isLoading 'thumbnail--loading'}}"
    ...attributes
  >
    <div class="thumbnail__image">
      {{#if @imageURL}}
        <img
          alt={{@imageAlt}}
          class="w-full"
          data-test-id="thumbnail-image"
          src={{@imageURL}}
        />
      {{/if}}
    </div>
    <div class="flex flex-col gap-100 pt-200 pr-300 pb-200 pl-300">
      <div class="text-300--regular truncate" data-test-id="thumbnail-title">
        {{#if @isLoading}}
          <div class="loading-pulse loading-pulse--col-6 mt-200"></div>
        {{else}}
          {{#if (has-block "title")}}
            {{yield to="title"}}
          {{else}}
            {{@title}}
          {{/if}}
        {{/if}}
      </div>
      <div
        class="thumbnail__subtitle text-200--regular truncate"
        data-test-id="thumbnail-subtitle"
      >
        {{#if @isLoading}}
          <div class="loading-pulse loading-pulse--col-3 mt-200"></div>
        {{else}}
          {{#if (has-block "subtitle")}}
            {{yield to="subtitle"}}
          {{else}}
            {{@subtitle}}
          {{/if}}
        {{/if}}
      </div>
    </div>
  </div>
</template> satisfies TOC<MarketCustomReportingThumbnailSignature>;

export default MarketCustomReportingThumbnail;
